export const getPromoCountdown = (expiryTime: string | undefined) => {
  return (new Date(expiryTime ?? Date.now()).getTime() - new Date().getTime()) / 1000;
};
